/** @jsx isolateComponent */

import { Button, Spacer, Text } from '@zapier/design-system';
import { isolateComponent } from '@zapier/style-encapsulation';

const styles = {
  container: {
    margin: '0 auto',
    maxWidth: 600,
    textAlign: 'center' as 'center',
  },
};

type Props = {
  message: string;
};

export const Error = ({ message }: Props) => (
  <div css={styles.container}>
    <Text tag="h1" type="subHeader1Bold">
      Something went wrong.
    </Text>

    <Spacer height={20} />

    <Text color="gray60" tag="p" type="bodyText800">
      {message}
    </Text>

    <Spacer height={30} />

    <Button hasShadow={true} href="/app/get-help" key="get-help">
      Get help
    </Button>
  </div>
);
